import { render, staticRenderFns } from "./SystemOverviewTab.vue?vue&type=template&id=607ac288&"
import script from "./SystemOverviewTab.vue?vue&type=script&lang=js&"
export * from "./SystemOverviewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports